import Divider from 'components/common/Divider';
import PropTypes from 'prop-types';
import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'api/axios';

const LOGIN_URL = '/users/signin';

const LoginForm = ({ hasLabel, layout }) => {
  const userRef = useRef();
  const navigate = useNavigate();

  // State
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    remember: false
  });

  // Handler
  const handleSubmit = async e => {
    e.preventDefault();

    try {
      const response = await axios.post(LOGIN_URL, {
        username: formData.username,
        password: formData.password
      });
      
      localStorage.setItem('accessUser', JSON.stringify(response?.data));
      toast.success(`Logged in as ${formData.username}`, {
        theme: 'colored'
      });
      navigate('/');
    } catch (err) {
      if (!err?.response) {
        toast.error('No Server Response');
      } else if (err?.response.status === 400) {
        toast.error(err?.response.data.message);
      }
    }
    // axios
    //   .get('http://192.168.1.109:3100/api/v1/users')
    //   .then(function (response) {
    //     console.log(response);
    //   });
    // e.preventDefault();
    // toast.success(`Logged in as ${formData.email}`, {
    //   theme: 'colored'
    // });
  };

  const handleFieldChange = e => {
    let value = e.target.value
    if (e.target.name === 'remember') {
      value = e.target.checked
    }
    setFormData({
      ...formData,
      [e.target.name]: value
    });
  };

  useEffect(() => {
    userRef.current.focus();
  }, []);

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Username</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Username' : ''}
          value={formData.email}
          name="username"
          onChange={handleFieldChange}
          type="text"
          ref={userRef}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Password</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Password' : ''}
          value={formData.password}
          name="password"
          onChange={handleFieldChange}
          type={formData.remember ? "text" : "password"}
        />
      </Form.Group>

      <Row className="justify-content-between align-items-center">
        <Col xs="auto">
          <Form.Check type="checkbox" id="rememberMe" className="mb-0">
            <Form.Check.Input
              type="checkbox"
              name="remember"
              checked={formData.remember}
              onChange={handleFieldChange}
            />
            <Form.Check.Label className="mb-0 text-700">
              Show Password
            </Form.Check.Label>
          </Form.Check>
        </Col>

        <Col xs="auto">
          <Link
            className="fs--1 mb-0"
            to={`/authentication/${layout}/forgot-password`}
          >
          </Link>
        </Col>
      </Row>

      <Form.Group>
        <Button
          type="submit"
          color="primary"
          className="mt-3 w-100"
          disabled={!formData.username || !formData.password}
        >
          Log in
        </Button>
      </Form.Group>

      <Divider className="mt-4 d-none">or log in with</Divider>
    </Form>
  );
};

LoginForm.propTypes = {
  layout: PropTypes.string,
  hasLabel: PropTypes.bool
};

LoginForm.defaultProps = {
  layout: 'simple',
  hasLabel: false
};

export default LoginForm;
